import { render, staticRenderFns } from "./unit_edit_form.vue?vue&type=template&id=460862ba&scoped=true&"
import script from "./unit_edit_form.vue?vue&type=script&lang=js&"
export * from "./unit_edit_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460862ba",
  null
  
)

export default component.exports